import { Box, Button, Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import theme from '../../theme';

type RespondentFilterFooterProps = {
    loading?: boolean;
    respondentCount: number;
    projectCount?: number;
    onClear(): void;
    onFilter(): void;
};
export const RespondentFilterFooter = (props: RespondentFilterFooterProps) => {
    return (
        <Grid
            container
            alignItems="center"
            mt={0}
            spacing={4}
            sx={(theme) => ({ color: theme.bino.color.white })}
        >
            <Grid item xs={12} sm={6}>
                <Box
                    sx={{
                        fontSize: 12,
                        textTransform: 'uppercase',
                        letterSpacing: '0.6px',
                        fontWeight: 'bold',
                        color: theme.color.white,
                        my: 1,
                        opacity: props.loading ? 0.1 : null,
                    }}
                >
                    <FormattedMessage
                        defaultMessage="{totalRespondents} {
                                            totalRespondents,
                                            plural,
                                            one { respondent selected}
                                            other {respondents selected}
                                            } "
                        description="The number of respondents selected with the current filter"
                        values={{
                            totalRespondents: `${props.respondentCount}`,
                        }}
                    />
                    {props.projectCount > 0 && (
                        <FormattedMessage
                            defaultMessage="from {totalProjects} {
                                            totalProjects,
                                            plural,
                                            one { project }
                                            other { projects }
                                            } "
                            description="The number of projects selected with the current filter"
                            values={{
                                totalProjects: props.projectCount,
                            }}
                        />
                    )}
                </Box>
            </Grid>
            <Grid item xs={6} sm={3}>
                <Button
                    fullWidth
                    variant="outlined"
                    color="white"
                    onClick={props.onClear}
                >
                    <FormattedMessage defaultMessage="Clear Filters" />
                </Button>
            </Grid>
            <Grid item xs={6} sm={3}>
                <Button
                    fullWidth
                    variant="containedInverted"
                    onClick={props.onFilter}
                >
                    <FormattedMessage defaultMessage="Apply Filters" />
                </Button>
            </Grid>
        </Grid>
    );
};
